import React from 'react';
import classNames from 'classnames';
import './LoadMore.css';
import { useTranslations } from '../../../../shared/src/hooks/use-translations.hook';

export const LoadMore = ({
    className = '',
    clickHandler,
    variant = 'default',
}) => {
    const { t } = useTranslations();
    const blockClassName = classNames(
        'grid-load-more',
        `grid-load-more--v-${variant}`,
        className,
    );

    return (
        <div
            onClick={clickHandler}
            className={blockClassName}
        >{t('moreGames')}</div>
    );
};
